const sendKlaviyoEvent = (email, toolName) => {
    if(!window.klaviyo) {
        return;
    }

    klaviyo.identify({
        'email' : email
    }, () => {
        klaviyo.track('Visited page', {
            'page' : toolName
        });
    });
}
export default {
    sendKlaviyoEvent
}
